"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = _interopRequireDefault(require("../../utils/createStyles"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread({
  notifyItem: {
    width: theme.notify.width,
    borderStyle: 'solid',
    borderWidth: theme.notify.borderWidth,
    boxShadow: theme.notify.boxShadow,
    margin: '12px 0',
    backgroundColor: theme.notify.bgColor,
    boxSizing: 'border-box',
    overflow: 'hidden'
  }
}, (0, _createStyles.default)('borderRadius', theme.borderRadius)), {}, {
  titleContainer: {
    padding: '8px 12px',
    boxSizing: 'border-box'
  },
  title: {
    flex: '1 1 auto',
    position: 'relative',
    top: -1,
    color: theme.notify.textColor,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  icon: {
    flex: '0 0 auto'
  },
  closeIcon: {
    flex: '0 0 auto',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  descriptionContainer: {
    borderStyle: 'solid',
    borderWidth: 0,
    borderTopWidth: theme.notify.borderWidth,
    padding: '8px 12px'
  },
  description: {
    color: theme.notify.textColor,
    'word-break': 'break-all'
  },
  primary: {
    borderColor: theme.palette.primary,
    '& $titleContainer': {
      backgroundColor: theme.fullPalette.bgActiveColor
    },
    '& $descriptionContainer': {
      borderColor: theme.palette.primary
    },
    '& $closeIcon, & $icon': {
      color: theme.palette.primary
    }
  },
  normal: {
    borderColor: theme.notify.normalBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.normalTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.normalBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.normalIconColor
    }
  },
  success: {
    borderColor: theme.notify.successBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.successTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.successBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.successIconColor
    }
  },
  error: {
    borderColor: theme.notify.errorBorderColor,
    '& $titleContainer': {
      backgroundColor: theme.notify.errorTitleBgColor
    },
    '& $descriptionContainer': {
      borderColor: theme.notify.errorBorderColor
    },
    '& $closeIcon, & $icon': {
      color: theme.notify.errorIconColor
    }
  }
});
exports.default = _default;